import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const DragDropTest = () => {
    const [items, setItems] = useState([
        { id: 1, name: 'กลุ่มที่ 1' },
        { id: 2, name: 'กลุ่มที่ 2' },
        { id: 3, name: 'กลุ่มที่ 3' },
        { id: 4, name: 'กลุ่มที่ 4' },
    ]);

    const [draggedIndex, setDraggedIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = (e, index) => {
        e.preventDefault();
        setDraggedIndex(index);
        setIsDragging(true);

        const handleMouseMove = (e) => {
            if (!isDragging) return;

            const elements = document.elementsFromPoint(e.clientX, e.clientY);
            const rowElement = elements.find(el => el.dataset && el.dataset.rowIndex !== undefined);

            if (rowElement) {
                const hoverIndex = parseInt(rowElement.dataset.rowIndex);
                if (hoverIndex !== draggedIndex) {
                    setDragOverIndex(hoverIndex);
                }
            }
        };

        const handleMouseUp = () => {
            if (dragOverIndex !== null && draggedIndex !== null && dragOverIndex !== draggedIndex) {
                const newItems = [...items];
                const draggedItem = newItems.splice(draggedIndex, 1)[0];
                newItems.splice(dragOverIndex, 0, draggedItem);
                setItems(newItems);
            }

            setIsDragging(false);
            setDraggedIndex(null);
            setDragOverIndex(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    return (
        <View style={styles.container}>
            <Text style={styles.title}>🧪 Drag & Drop Test</Text>
            <Text style={styles.subtitle}>Click and drag the ⋮⋮ handle to reorder items</Text>

            {items.map((item, index) => {
                const isCurrentlyDragging = isDragging && draggedIndex === index;
                const isDropTarget = dragOverIndex === index;

                return (
                    <View
                        key={item.id}
                        data-row-index={index}
                        style={[
                            styles.row,
                            isCurrentlyDragging && styles.dragging,
                            isDropTarget && styles.dropTarget,
                        ]}
                    >
                        <TouchableOpacity
                            onPressIn={(e) => handleMouseDown(e.nativeEvent, index)}
                            style={styles.dragHandle}
                        >
                            <Text style={styles.dragIcon}>⋮⋮</Text>
                        </TouchableOpacity>

                        <View style={styles.content}>
                            <Text style={styles.itemText}>{item.name}</Text>
                            <Text style={styles.itemId}>ID: {item.id}</Text>
                        </View>
                    </View>
                );
            })}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        padding: 20,
        backgroundColor: '#f5f5f5',
        minHeight: 400,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 10,
        textAlign: 'center',
    },
    subtitle: {
        fontSize: 14,
        color: '#666',
        marginBottom: 20,
        textAlign: 'center',
    },
    row: {
        flexDirection: 'row',
        backgroundColor: 'white',
        marginBottom: 8,
        borderRadius: 8,
        padding: 12,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
    },
    dragging: {
        opacity: 0.6,
        transform: [{ scale: 1.02 }],
        zIndex: 1000,
    },
    dropTarget: {
        borderWidth: 2,
        borderColor: '#002377',
        borderStyle: 'dashed',
        backgroundColor: 'rgba(0, 35, 119, 0.1)',
    },
    dragHandle: {
        width: 30,
        height: 30,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 35, 119, 0.1)',
        borderRadius: 4,
        marginRight: 12,
    },
    dragIcon: {
        fontSize: 16,
        color: '#002377',
        fontWeight: 'bold',
    },
    content: {
        flex: 1,
    },
    itemText: {
        fontSize: 16,
        fontWeight: '500',
        marginBottom: 2,
    },
    itemId: {
        fontSize: 12,
        color: '#666',
    },
});

export default DragDropTest;
